import * as React from 'react';

/* --- PDP components --- */
import { OverviewBadge } from './PromoInformation/OverviewBadge';
import { DetailsDescription } from './DetailsDescription/DetailsDescription';
import { Sku } from './SKU/Sku';
import { OverviewPromoText } from './PromoInformation/OverviewPromoText';
import { RichTextCTA } from './RichTextCTA/RichTextCTA';
import {Actions} from "./Actions/Actions";
import { RelatedProductsInformation } from '../RelatedProducts/RelatedProductsInformation';
import {Bundles} from "./Bundles/Bundles";


export const ProductOverview = () => {
    return (
        <div className="pdp__overview">
            <OverviewBadge />

            <DetailsDescription />

            <Sku enabled={true} />

            <OverviewPromoText />

            <RichTextCTA />

            <Actions />

            <RelatedProductsInformation />

            <Bundles />
        </div>
    );
}
